export default "__VITE_ASSET__08081a2d__"